// eslint-disable-next-line @typescript-eslint/no-var-requires
const appVersion = require('../../package.json').version;

export const environment = {
  appVersion: appVersion,
  production: true,
  apiUrl: 'https://strike-2-api.unitehere.org/Strike',
  apiHostHeader: 'strike-2-api.unitehere.org',
  localNumber: '2',
  deploymentType: 'production'
};
